<template>
  <b-container
    fluid
    class="bg-white shadow-inset-top"
    style="min-height: calc(100vh - 95px); max-height: calc(100vh - 95px); overflow-y: auto"
    data-cy="return-list-main-container"
  >
  <b-row style="height: 100%" data-cy="return-list-main-row">
      <b-col cols="12" data-cy="return-list-content-col">
        <b-container
          class="p-4 p-md-5"
          style="min-height: calc()"
          data-cy="return-list-content-container"
        >
          <b-row>
            <b-col
              cols="12"
              v-if="returns.length > 0"
              class="mb-5"
              data-cy="return-list-header-col"
            >
              <h4
                class="text-primary font-weight-bold"
                data-cy="return-list-title"
              >
                Retorno
              </h4>
              <small class="font-weight-bold" data-cy="return-list-subtitle"
                >Selecione o Retorno que deseja agendar</small
              >
            </b-col>

            <b-col cols="12" data-cy="return-list-list-col">
              <div
                class="text-primary text-uppercase"
                data-cy="return-list-list-container"
              >
                <div
                  :class="
                    `custom-radio-wrapper mb-2 ${
                      selectedReturn && selectedReturn.id === object.id
                        ? 'border-primary'
                        : ''
                    }`
                  "
                  v-for="object in returns"
                  :key="object.id"
                  :data-cy="`return-list-item-${object.id}`"
                >
                  <div
                    class="custom-control custom-radio"
                    data-cy="return-list-radio-wrapper"
                  >
                    <input
                      type="radio"
                      :id="'return-' + object.id"
                      name="return"
                      class="custom-control-input"
                      :value="object"
                      :checked="
                        selectedReturn && selectedReturn.id === object.id
                      "
                      @change="submit(object)"
                      :data-cy="`return-list-radio-${object.id}`"
                    />
                    <label
                      class="custom-control-label d-inline-flex flex-column"
                      :for="'return-' + object.id"
                      :data-cy="`return-list-label-${object.id}`"
                    >
                      <span data-cy="return-list-label-clinica">
                        <strong>Clinica:</strong>
                        {{ object.clinica.nome }}
                      </span>
                      <span
                        class="small my-1"
                        data-cy="return-list-label-endereco"
                      >
                        <strong>Endereço:</strong>
                        {{ object.clinica | clinicAddress }}
                      </span>
                      <span
                        class="small my-1"
                        data-cy="return-list-label-paciente"
                      >
                        <strong>Paciente:</strong>
                        {{ object.usuarioPortal.nome }}
                      </span>
                      <span
                        class="small my-1"
                        data-cy="return-list-label-convenio-profissional"
                      >
                        <b-row>
                          <b-col md="auto" data-cy="return-list-label-convenio">
                            <strong>Convênio:</strong>
                            {{ object.convenio.nome }}
                          </b-col>
                          <b-col
                            md="auto"
                            data-cy="return-list-label-profissional"
                          >
                            <strong>Profissional:</strong>
                            {{ object.profissional.nome }}
                          </b-col>
                        </b-row>
                      </span>
                      <span
                        class="small my-1"
                        data-cy="return-list-label-procedimento-retorno"
                      >
                        <b-row>
                          <b-col
                            md="auto"
                            data-cy="return-list-label-procedimento"
                          >
                            <strong>Procedimento:</strong>
                            {{ object.procedimento.nome }}
                          </b-col>
                          <b-col
                            md="auto"
                            data-cy="return-list-label-retorno-max"
                          >
                            <strong>Data máxima para retorno:</strong>
                            {{
                              dataMaximaRetorno(object.procedimento.diasRetorno)
                            }}
                          </b-col>
                        </b-row>
                      </span>
                      <span
                        class="small my-1"
                        data-cy="return-list-label-consulta-horario"
                      >
                        <b-row>
                          <b-col
                            md="auto"
                            data-cy="return-list-label-consulta-data"
                          >
                            <strong>Data da consulta:</strong>
                            {{ formatDataConsulta(object.horaAgendamento) }}
                          </b-col>
                          <b-col
                            md="auto"
                            data-cy="return-list-label-consulta-horario-col"
                          >
                            <strong>Horário da consulta:</strong>
                            {{ formatHorarioConsulta(object.horaAgendamento) }}
                          </b-col>
                        </b-row>
                      </span>
                    </label>
                  </div>
                </div>
              </div>
            </b-col>

            <b-col
              cols="12"
              class="text-center"
              v-if="returns.length === 0 && loading"
              data-cy="return-list-loading-col"
            >
              <b-spinner
                variant="primary"
                data-cy="return-list-loading-spinner"
              ></b-spinner>
            </b-col>
          </b-row>
          <b-alert
            show
            variant="danger"
            v-if="returns.length === 0 && !loading"
            data-cy="return-list-empty-alert"
          >
            <h4 class="alert-heading" data-cy="return-list-empty-title">
              Não há retornos Disponíveis
            </h4>
            <p data-cy="return-list-empty-message">
              Não localizamos em nossa base de dados retornos disponíveis para
              seu usuário ou um de seus dependentes.
            </p>
            <hr data-cy="return-list-empty-hr" />
            <p class="mb-0" data-cy="return-list-empty-historico">
              Caso deseje verificar seu histórico de agendamentos,
              <router-link
                :to="{
                  name: 'history',
                  params: { organizationId: $route.params.organizationId }
                }"
                data-cy="return-list-empty-historico-link"
                >clique aqui</router-link
              >
            </p>
            <br />
            <br />
            <p class="text-center" data-cy="return-list-empty-btn-row">
              <b-button
                variant="primary"
                :to="{
                  name: 'index',
                  params: { organizationId: $route.params.organizationId }
                }"
                data-cy="return-list-empty-btn-voltar"
                >Voltar à Principal</b-button
              >
            </p>
          </b-alert>
          <b-row v-if="returns.length > 0" data-cy="return-list-actions-row">
            <b-col class="bg-white" data-cy="return-list-actions-col">
              <hr class="w-100 my-5" data-cy="return-list-actions-hr" />
              <div
                id="workflow-buttons-wrapper"
                class="d-flex justify-content-between"
                data-cy="return-list-actions-btn-wrapper"
              >
                <router-link
                  :to="{
                    name: 'index',
                    params: { organizationId: $route.params.organizationId }
                  }"
                  class="btn btn-outline-primary btn-lg rounded-0 d-flex justify-content-center align-items-center flex-grow-1 flex-md-grow-0"
                  data-cy="return-list-btn-voltar"
                  >Voltar à principal</router-link
                >

                <router-link
                  :to="{
                    name: 'return_horario',
                    params: {
                      organizationId: $route.params.organizationId,
                      agendaId: selectedReturn ? selectedReturn.id : 0
                    }
                  }"
                  :class="
                    `${
                      !selectedReturn ? 'disabled' : ''
                    } btn btn-primary btn-lg rounded-0 d-flex justify-content-center align-items-center flex-grow-1 flex-md-grow-0`
                  "
                  data-cy="return-list-btn-selecionar-horario"
                  >Selecionar Horário</router-link
                >
              </div>
            </b-col>
          </b-row>
        </b-container>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import { axiosInstance as Axios } from "@/main";
import moment from "moment";

export default {
  name: "return-list",
  data() {
    return {
      loading: false,
      returns: []
    };
  },
  computed: {
    selectedReturn() {
      return this.$store.getters.selected_return;
    }
  },
  methods: {
    submit(object) {
      this.$store.dispatch("set_selectedreturn", object);
    },
    formatDataConsulta(data) {
      return moment(data).format("DD/MM/YYYY");
    },
  formatHorarioConsulta(data) {
      return moment(data).format("HH:mm");
    },
    dataMaximaRetorno(dias) {
      return moment()
        .add("days", dias)
        .format("DD/MM/YYYY");
    }
  },
  async mounted() {
    try {
      this.loading = true;
      let response = await Axios.get(
        `${this.$serverHost}protected/me/retornos`,
        {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`
          }
        }
      );

      this.returns = response.data.content;
      this.loading = false;
    } catch (e) {
      console.log(e);
    } finally {
      this.loading = false;
    }
  }
};
</script>

<style></style>
